"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    miao: '[+3]',
    wang: '[+2]',
    de: '[+1]',
    li: '[0]',
    ping: '[-1]',
    bu: '[-2]',
    xian: '[-3]',
};
